import React from 'react';
import {View} from 'react-native';
import {useForm, FormProvider} from 'react-hook-form';
import {RHButton} from 'src/common-components/custom-ui-helpers';
import {useStyle} from 'src/providers/style';
import {useTranslations} from 'src/providers/translation';
import {withDatabase} from '@nozbe/watermelondb/react';
import {withObservables} from '@nozbe/watermelondb/react';
import {of} from 'rxjs';
import {Q} from '@nozbe/watermelondb';
import {compose} from 'recompose';

import CredentialForm from 'src/modules/patients/components/credential-form';
import {Payer, PayerCredential} from 'src/models';
import _ from 'lodash';
interface Props {
  onAssign: any;
  physician: any;
  payers?: any;
  payerCredentials?: any;
}

const PhysicianForm = ({
  onAssign,
  physician,
  payers,
  payerCredentials,
}: Props) => {
  const styles = useStyle();
  const translations = useTranslations();

  const mappedPayers = _.keyBy(payerCredentials, 'payerId');
  const methods = useForm({
    defaultValues: {
      referring: {
        tin: physician?.tin || '',
        npi: physician?.npi || '',
        ssn: physician?.ssn || '',
        taxonomy: physician?.taxonomy || '',
        firstName: physician?.firstName || '',
        middleName: physician?.middleName || '',
        lastName: physician?.lastName || '',
        payers: payers?.map((payer: any) => {
          return {
            _id: mappedPayers[payer.id]?.id,
            id: payer.id,
            legacyId: mappedPayers[payer.id]?.legacyId || '',
          };
        }),
      },
    },
  });
  return (
    <FormProvider {...methods}>
      <CredentialForm
        name={'referring'}
        box={'(Box 17)'}
        entity={physician}
        extraFields={false}
        showTaxonomy={true}
        physicianForm={true}
      />
      <View style={[styles.row, styles.alignCenter, styles.justifyEnd]}>
        <RHButton
          secondary
          mode="contained"
          onPress={methods.handleSubmit(onAssign)}>
          {translations('save_button')}
        </RHButton>
      </View>
    </FormProvider>
  );
};
export default compose(
  withDatabase,
  withObservables([], ({database, selectedGroup, physician}: any) => {
    return {
      payers: database
        .get(Payer.table)
        .query(
          Q.where('staff_ids', true),
          Q.where('_partition', selectedGroup),
          Q.where('deleted_at', Q.eq(null)),
        ),
      payerCredentials: physician
        ? database
            .get(PayerCredential.table)
            .query(
              Q.where('credential_id', physician.id),
              Q.where('deleted_at', Q.eq(null)),
            )
        : of([]),
    };
  }),
)(PhysicianForm);
